import { Link } from 'react-router-dom';
import { fonogramasData } from '@/mocks/derechos-data';

export default function FonogramasModule() {
  return (
    <section id="fonogramas" className="py-16 md:py-24 bg-background-50">
      {/* Intro Section */}
      <div className="px-4 md:px-6 lg:px-10 mb-16 md:mb-20">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Image */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden h-[300px] md:h-[420px]">
                <img
                  src={fonogramasData.introduccion.imagen}
                  alt="Músicos en sesión de grabación"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Decorative element */}
              <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-full bg-primary-500/10 border border-primary-500/20 hidden lg:block" />
            </div>

            {/* Text */}
            <div>
              <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-600 mb-3">
                Módulo Fonograma
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight mb-5">
                {fonogramasData.introduccion.titulo}
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
                {fonogramasData.introduccion.parrafo1}
              </p>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                {fonogramasData.introduccion.parrafo2}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Infografía: ¿Cómo funciona la gestión? */}
      <div className="px-4 md:px-6 lg:px-10 mb-16 md:mb-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-600 mb-2">
              Proceso
            </span>
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              ¿Cómo funciona la gestión?
            </h3>
          </div>

          {/* Desktop: Horizontal flow */}
          <div className="hidden lg:block">
            <div className="relative">
              {/* Connecting line */}
              <div className="absolute top-12 left-[8%] right-[8%] h-0.5 bg-gradient-to-r from-primary-200 via-primary-400 to-primary-200" />

              <div className="grid grid-cols-7 gap-3 relative">
                {fonogramasData.infografia.map((paso) => (
                  <div key={paso.paso} className="flex flex-col items-center text-center group">
                    {/* Circle with number */}
                    <div className="relative z-10 w-10 h-10 rounded-full bg-primary-500 text-white flex items-center justify-center text-xs font-bold mb-4 shadow-[0_0_20px_rgba(var(--primary-500),0.3)] group-hover:scale-110 transition-transform duration-300">
                      {paso.paso}
                    </div>
                    {/* Icon */}
                    <div className="w-9 h-9 rounded-lg bg-primary-50 flex items-center justify-center mb-2">
                      <i className={`${paso.icono} text-primary-600 text-base`} />
                    </div>
                    {/* Label */}
                    <p className="text-foreground-900 text-xs font-bold mb-1 leading-tight whitespace-nowrap">
                      {paso.etiqueta}
                    </p>
                    {/* Description */}
                    <p className="text-foreground-500 text-[10px] leading-snug">
                      {paso.descripcion}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Mobile: Vertical flow */}
          <div className="lg:hidden space-y-4">
            {fonogramasData.infografia.map((paso, idx) => (
              <div key={paso.paso} className="flex gap-4 items-start">
                {/* Vertical connector */}
                <div className="flex flex-col items-center">
                  <div className="w-9 h-9 rounded-full bg-primary-500 text-white flex items-center justify-center text-xs font-bold flex-shrink-0">
                    {paso.paso}
                  </div>
                  {idx < fonogramasData.infografia.length - 1 && (
                    <div className="w-0.5 h-8 bg-primary-200 mt-1" />
                  )}
                </div>
                {/* Content */}
                <div className="pb-4">
                  <div className="flex items-center gap-2 mb-1">
                    <div className="w-7 h-7 rounded-lg bg-primary-50 flex items-center justify-center">
                      <i className={`${paso.icono} text-primary-600 text-sm`} />
                    </div>
                    <p className="text-foreground-900 text-sm font-bold">{paso.etiqueta}</p>
                  </div>
                  <p className="text-foreground-500 text-xs">{paso.descripcion}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Caja Destacada: ¿Quién realiza la recaudación? */}
      <div className="px-4 md:px-6 lg:px-10 mb-16 md:mb-20">
        <div className="max-w-4xl mx-auto">
          <div className="relative bg-white border border-secondary-200/60 rounded-2xl p-7 md:p-10 overflow-hidden">
            {/* Accent bar */}
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-primary-500 rounded-r-full" />

            {/* Corner decoration */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-primary-50/50 rounded-bl-[80px] -mr-4 -mt-4" />

            <div className="relative">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-information-line text-primary-600 text-lg" />
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                  {fonogramasData.cajaRecaudacion.titulo}
                </h3>
              </div>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-3">
                {fonogramasData.cajaRecaudacion.parrafo1}
              </p>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                {fonogramasData.cajaRecaudacion.parrafo2}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ¿Quiénes utilizan fonogramas? */}
      <div className="px-4 md:px-6 lg:px-10 mb-16 md:mb-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              ¿Quiénes utilizan fonogramas?
            </h3>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">
              Estos son los principales establecimientos y medios que comunican públicamente fonogramas y deben regularizar su situación.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {fonogramasData.usuarios.map((usuario) => (
              <div
                key={usuario.nombre}
                className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-2xl bg-white border border-secondary-100 hover:border-primary-200/50 transition-all duration-300 hover:-translate-y-1 cursor-default"
              >
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors duration-300">
                  <i className={`${usuario.icono} text-primary-500 text-lg md:text-xl`} />
                </div>
                <span className="text-foreground-700 text-xs md:text-sm font-medium text-center leading-tight whitespace-nowrap">
                  {usuario.nombre}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* SOY USUARIO / SOY ARTISTA */}
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
            {/* SOY USUARIO */}
            <div className="bg-primary-500 rounded-3xl p-7 md:p-10 text-white relative overflow-hidden group">
              {/* Decorative circles */}
              <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-white/8" />
              <div className="absolute -bottom-8 -left-8 w-28 h-28 rounded-full bg-white/5" />

              <div className="relative z-10">
                <div className="w-12 h-12 rounded-2xl bg-white/15 flex items-center justify-center mb-5">
                  <i className="ri-building-2-line text-white text-xl" />
                </div>
                <h3 className="font-heading text-2xl md:text-3xl font-bold mb-3">
                  Soy Usuario
                </h3>
                <p className="text-white/75 text-sm leading-relaxed mb-4">
                  {fonogramasData.soyUsuario.descripcion}
                </p>
                <a
                  href={fonogramasData.soyUsuario.botonUrl}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-primary-600 font-semibold text-sm hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <span>{fonogramasData.soyUsuario.botonTexto}</span>
                  <i className="ri-external-link-line" />
                </a>
                <p className="text-white/50 text-xs mt-4 leading-relaxed">
                  {fonogramasData.soyUsuario.nota}
                </p>
              </div>
            </div>

            {/* SOY ARTISTA */}
            <div className="bg-foreground-950 rounded-3xl p-7 md:p-10 text-white relative overflow-hidden group">
              {/* Decorative circles */}
              <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-white/[0.03]" />
              <div className="absolute -bottom-8 -left-8 w-28 h-28 rounded-full bg-white/[0.02]" />

              <div className="relative z-10">
                <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center mb-5">
                  <i className="ri-user-star-line text-white text-xl" />
                </div>
                <h3 className="font-heading text-2xl md:text-3xl font-bold mb-3">
                  Soy Artista
                </h3>

                {/* Botón Afíliate */}
                <p className="text-white/60 text-xs leading-relaxed mb-3">
                  {fonogramasData.soyArtista.descripcionAfiliate}
                </p>
                <Link
                  to="/contacto"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap mb-6 cursor-pointer"
                >
                  <span>Afíliate a SONIEM</span>
                  <i className="ri-arrow-right-line" />
                </Link>

                {/* Botón Registrar */}
                <div className="border-t border-white/10 pt-5">
                  <p className="text-white/60 text-xs leading-relaxed mb-3">
                    {fonogramasData.soyArtista.descripcionRegistro}
                  </p>
                  <Link
                    to="/intranet"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 text-white font-semibold text-sm border border-white/20 hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    <span>Registrar Producciones</span>
                    <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}